module.exports = __webpack_public_path__ + "img/18.3fd8bcfc.jpg";